import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NewsArticle = () => {
  const { slug } = useParams();

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <Link to="/news" className="inline-flex items-center space-x-2 text-gray-700 hover:text-green-600 mb-6 transition-colors" data-discover="true">
            <ArrowLeft className="w-5 h-5" />
            <span>Back to News</span>
          </Link>
          <div className="glass-strong p-8 rounded-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
              Article: {slug}
            </h1>
            <p className="text-gray-700">
              This article page will be created later.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewsArticle;

